import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useFlushRedis = () => {
  return useMutation([`flushRedis`], () =>
    apiFetch(null, `internal/expert-management/flushRedis`, {
      method: 'POST',
    }),
  );
};
